<template>
    <div class="container text-center my-4">
      <h2>Bienvenido a Esta Nueva Experiencia</h2>
      <p>Gracias por unirte a nosotros.</p>
      <router-link to="/" @click="resetProcess" class="btn btn-link">Volver a la Página Inicial</router-link>
    </div>
  </template>
  
  <script>
  export default {
    name: 'WelcomeNewExperience',
    methods: {
      resetProcess() {
        this.$emit('reset'); // Emite el evento 'reset' directamente
      }
    }
  };
  </script>
  
  <style scoped>
  h2 {
    color: #28a745;
  }
  
  p {
    font-size: 1.1em;
    margin-top: 20px;
  }
  </style>
  